import Cta from "@components/Cta/Cta";
import Grid from "@components/Grid/Grid";
import { useSettings } from "@utilities/context/settings";
import clsx from "clsx";
import { useContext, useEffect, useRef, useState } from "react";
import { ProgrammeContext } from "../../context/programmeComparison";
import ChevronSvg from "../../public/image/svg/chevron.svg";
import CrossSvg from "../../public/image/svg/cross.svg";
import styles from "./C242_ComparisonOverlay.module.scss";

export const ComparisonOverlay = () => {
  const { programmeSettings } = useSettings();
  const { programmes, removeProgramme, type } = useContext(ProgrammeContext);
  const {
    programmeComparisonOverlayCtaLinkEe,
    programmeComparisonOverlayCtaLinkDe,
    programmeComparisonOverlayText,
    programmeComparisonOverlayMoreText,
    programmeComparisonOverlayOneMoreText,
    programmeComparisonOverlayCtaText,
  } = programmeSettings;
  const [expanded, setExpanded] = useState(true);
  const [collapseHeight, setCollapseHeight] = useState(0);
  const collapseRef = useRef<HTMLDivElement>(null);

  useEffect(() => {
    if (collapseRef.current && expanded) {
      setCollapseHeight(collapseRef.current.getBoundingClientRect().height);
    }
  }, [collapseRef, expanded, programmes]);

  if (!programmes?.length) {
    return null;
  }

  return (
    <div
      className={clsx(
        styles["comparison-overlay"],
        programmes.length && styles["has-items"]
      )}
    >
      <div className={`${styles["inner-wrapper"]} wrapper`}>
        <Grid row>
          <Grid column sm={1}></Grid>
          <Grid column sm={10}>
            <button
              className={clsx(styles["toggle-wrapper"], "w-full")}
              tabIndex={0}
              aria-expanded={expanded}
              data-open={expanded}
              aria-label={expanded ? "Collapse" : "Expand"}
              onClick={() => setExpanded(!expanded)}
            >
              <span className={styles["icon-chevron"]} aria-hidden>
                <ChevronSvg />
              </span>
              <p>{programmeComparisonOverlayText}</p>
            </button>
            <div
              className={styles["collapse-wrapper"]}
              aria-hidden={!expanded}
              style={{ height: expanded ? `${collapseHeight}px` : 0 }}
            >
              <div className={styles["inner-wrapper"]} ref={collapseRef}>
                <div className={styles["programmes-wrapper"]}>
                  {programmes?.map((programme, i) => (
                    <div
                      className={styles.programme}
                      key={`${programme.programmeTitle}${i}`}
                    >
                      <div className={styles["inner-wrapper"]}>
                        <span className={styles.title}>
                          {programme.programmeTitle}
                        </span>
                      </div>
                      <button
                        className={styles["remove-block"]}
                        aria-label="remove programme"
                        tabIndex={0}
                        onClick={() => {
                          removeProgramme(programme);
                        }}
                      >
                        <span className="icon-cross">
                          <CrossSvg />
                        </span>
                      </button>
                    </div>
                  ))}

                  {programmes.length < 4 && (
                    <div className={styles["programme-blank"]}>
                      <div className={styles["inner-wrapper"]}>
                        <span className={styles.title}>
                          {programmes?.length < 2
                            ? programmeComparisonOverlayOneMoreText
                            : programmeComparisonOverlayMoreText}
                        </span>
                      </div>
                      <span className={styles["plus-icon"]}></span>
                    </div>
                  )}
                </div>
                <div className="button-wrapper">
                  {programmes.length > 1 && (
                    <Cta
                      type="tertiary"
                      light={true}
                      icon="icon-arrow-small"
                      url={`${
                        type === "DE"
                          ? programmeComparisonOverlayCtaLinkDe?.slug
                          : programmeComparisonOverlayCtaLinkEe?.slug
                      }?p=${programmes
                        ?.map((programme) => programme.programmeCode)
                        .join(",")}`}
                      linkText={programmeComparisonOverlayCtaText || ""}
                    />
                  )}
                </div>
              </div>
            </div>
          </Grid>
        </Grid>
      </div>
    </div>
  );
};

export default ComparisonOverlay;
